import { Link } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { useBooksellerMessages } from '../../hooks/useBooksellerMessages'
import LibraryMenu from './LibraryMenu'
import ProfilePill from './ProfilePill'

/**
 * Header for the Moja Biblioteka area.
 *
 * Desktop: single row aligned to the dashboard grid:
 *   - Left 1/3 column: logo, centered within its column.
 *   - Right 2/3 column: menu pill (left-aligned) + profile pill (right-aligned).
 * Mobile: logo and profile on one row, menu below.
 */
export default function LibraryHeader() {
  const { user } = useAuthStore()
  const { unreadCount } = useBooksellerMessages()

  return (
    <header className="w-full px-4 pt-6 pb-4">
      <div className="mx-auto w-full max-w-[75%]">
        {/* Mobile layout */}
        <div className="flex flex-col gap-4 lg:hidden">
          <div className="flex items-center justify-between">
            <Link
              to="/"
              className="font-climate text-brand-gold text-2xl sm:text-3xl leading-none drop-shadow-lg hover:opacity-90 transition"
            >
              Abonamenty<br />Literackie
            </Link>
            <ProfilePill user={user} />
          </div>
          <LibraryMenu unreadCounts={{ bookseller: unreadCount }} />
        </div>

        {/* Desktop layout — aligned to the 1/3 + 2/3 dashboard grid */}
        <div className="hidden lg:grid lg:grid-cols-3 lg:gap-6 items-start">
          <div className="lg:col-span-1 flex items-center justify-center h-full">
            <Link
              to="/"
              className="font-climate text-brand-gold text-3xl xl:text-4xl leading-none drop-shadow-lg hover:opacity-90 transition text-center"
            >
              Abonamenty Literackie
            </Link>
          </div>
          <div className="lg:col-span-2 flex items-center justify-between gap-4">
            <LibraryMenu unreadCounts={{ bookseller: unreadCount }} />
            <ProfilePill user={user} />
          </div>
        </div>
      </div>
    </header>
  )
}
